module.exports = __webpack_public_path__ + "static/media/copy_all_black_24dp.68d030e9.svg";